
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import {
forgetPwd
} from '../../api/public'

export default {
name: 'UserForgetPwd',
components: {
Flexbox,
FlexboxItem,
XButton,
XInput
},
data () {
return {
title: '潮州侨联',
newPwd: null,
newPwd2: null,
reqData: {
pwd: '',
sign: ''
},
count: 3,
myH: null
}
},
mounted () {
this.reqData.sign = this.$route.params.sign
},
methods: {
forgetPwd () {
if (this.newPwd === null || this.newPwd === '') {
this.$vux.toast.show({
type: 'text',
position: 'middle',
text: '密码不能为空！'
})
return
}
if (this.newPwd.length > 20 || this.newPwd.length < 8) {
this.$vux.toast.show({
type: 'text',
position: 'middle',
text: '密码长度在8-20个字符之间！'
})
return
}
if (this.newPwd2 === null || this.newPwd2 === '') {
this.$vux.toast.show({
type: 'text',
position: 'middle',
text: '确认密码不能为空！'
})
return
}
if (this.newPwd !== this.newPwd2) {
this.$vux.toast.show({
type: 'text',
position: 'middle',
text: '密码和确认密码不相同！'
})
return
}

this.reqData.pwd = this.newPwd
forgetPwd(this.reqData).then(res => {
if (res.status === 'SUCCESS') {
this.$vux.toast.show({
type: 'text',
position: 'middle',
text: '重置密码成功！'
})
setTimeout(() => {
this.$router.replace('/empty')
}, 3000)
}
})
}






























}
}



// WEBPACK FOOTER //
// ./src/components/user/resetPwd.vue